// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"9350720b","305":"792746dd","361":"90fa717b","396":"200bf5e7","470":"75b06229","513":"7ad0e402","585":"0fad43e8","599":"f71d2c66","664":"bd400957","718":"04fcbdb3","724":"87a0f6c0"}[chunkId] + ".chunk.js";
};